import { useFGContext } from "nsitools-react";
import * as React from "react";

export interface IDrupalDogUpdateProps {
  dogId: number;
}

export const DrupalDogUpdate: React.FunctionComponent<IDrupalDogUpdateProps> = ({ dogId }) => {
  var { formik } = useFGContext();
  const [previousDogId, setpreviousDogId] = React.useState(0);

  React.useEffect(() => {
    if (dogId && dogId !== previousDogId) {
      formik.setFieldValue("dogId", dogId);
    }
    setpreviousDogId(dogId);
  }, [dogId, formik, previousDogId]);
  return <></>;
};
